import React from 'react';

const RedPin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M3.75 12.75H14.25V11.43C14.2499 11.1509 14.1719 10.8774 14.0248 10.6403C13.8777 10.4031 13.6674 10.2117 13.4175 10.0875L12.0825 9.4125C11.8326 9.28832 11.6223 9.09688 11.4752 8.85972C11.3281 8.62255 11.2501 8.34906 11.25 8.07V4.5H12C12.3978 4.5 12.7794 4.34196 13.0607 4.06066C13.342 3.77936 13.5 3.39782 13.5 3C13.5 2.60218 13.342 2.22064 13.0607 1.93934C12.7794 1.65804 12.3978 1.5 12 1.5H6C5.60218 1.5 5.22064 1.65804 4.93934 1.93934C4.65804 2.22064 4.5 2.60218 4.5 3C4.5 3.39782 4.65804 3.77936 4.93934 4.06066C5.22064 4.34196 5.60218 4.5 6 4.5H6.75V8.07C6.74985 8.34906 6.67186 8.62255 6.52479 8.85972C6.37772 9.09688 6.16741 9.28832 5.9175 9.4125L4.5825 10.0875C4.33259 10.2117 4.12228 10.4031 3.97521 10.6403C3.82814 10.8774 3.75015 11.1509 3.75 11.43V12.75Z"
      fill="#B8341B"
    />
    <path
      d="M9 12.75V16.5M3.75 12.75H14.25V11.43C14.2499 11.1509 14.1719 10.8774 14.0248 10.6403C13.8777 10.4031 13.6674 10.2117 13.4175 10.0875L12.0825 9.4125C11.8326 9.28832 11.6223 9.09688 11.4752 8.85972C11.3281 8.62255 11.2501 8.34906 11.25 8.07V4.5H12C12.3978 4.5 12.7794 4.34196 13.0607 4.06066C13.342 3.77936 13.5 3.39782 13.5 3C13.5 2.60218 13.342 2.22064 13.0607 1.93934C12.7794 1.65804 12.3978 1.5 12 1.5H6C5.60218 1.5 5.22064 1.65804 4.93934 1.93934C4.65804 2.22064 4.5 2.60218 4.5 3C4.5 3.39782 4.65804 3.77936 4.93934 4.06066C5.22064 4.34196 5.60218 4.5 6 4.5H6.75V8.07C6.74985 8.34906 6.67186 8.62255 6.52479 8.85972C6.37772 9.09688 6.16741 9.28832 5.9175 9.4125L4.5825 10.0875C4.33259 10.2117 4.12228 10.4031 3.97521 10.6403C3.82814 10.8774 3.75015 11.1509 3.75 11.43V12.75Z"
      stroke="#B8341B"
      stroke-width="1.5"
      stroke-linecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RedPin;
